<template>
  <div class="beikostberatung">
    <h1>Beikostberatung: Sicherer Beikoststart für dein Baby (Online & Koblenz)</h1>
    <p>Das Kind darf Freude am Essen haben, und die Eltern möglichst wenig Stress damit. Mein Ziel ist es, euch Entspannung und Sicherheit auf dem Weg zur Beikost zu vermitteln. Gerne stelle ich euch verschiedene Konzepte wie klassischen Beikost-Brei oder Baby Led Weaning (BLW) vor. Es gibt in meiner Beikostberatung nicht den einen Weg – ihr als Familie entscheidet, welcher am besten zu euch und euren Ressourcen passt.</p>
    <p>Angelehnt an die aktuellen Empfehlungen kann ich euch Sicherheit geben, wie ihr den richtigen Zeitpunkt für den Beikoststart erkennen könnt.</p>
    <h2>Inhalte meiner Beikostberatung (Brei & Baby Led Weaning):</h2>
    <ul>
      <li>Wann ist der richtige Zeitpunkt für den Beikoststart? (Beikostreifezeichen)</li>
      <li>Verschiedene Wege der Beikost (Baby Led Weaning, Brei, Beikost nach Bedarf)</li>
      <li>Sicherheitsregeln am Familientisch</li>
      <li>Welche Lebensmittel sind geeignet, welche nicht?</li>
      <li>Wird mein Kind satt? Bekommt es alle wichtigen Nährstoffe?</li>
      <li>Wie viel Stillen/Flasche ist während der Beikostzeit noch „normal“?</li>
      <li>Was sind die Empfehlungen zur Allergieprävention?</li>
    </ul>
    <p>Für einen kompakten Überblick über die wichtigsten Punkte biete ich auch einen <router-link to="/beikostworkshop/">Beikostworkshop</router-link> an.</p>
    <button 
      class="cta-button" 
      @click="$router.push({ 
        path: '/kontakt', 
        query: { 
          topic: 'Beikostberatung' 
        } 
      })"
    >
      Jetzt Kontakt aufnehmen
    </button>
  </div>
</template>

<script>
export default {
  name: 'Beikostberatung'
}
</script>

<style scoped>
.beikostberatung {
}
</style>